<h1 class="page-title">Frequently Asked Questions</h1>
<mat-accordion>
  <app-expansion-panel title="1. How is my footprint calculated?">
    <p>
      The climate calculator tool
      <strong><i>Me and My Planet</i></strong> calculates your footprint in CO₂
      equivalents. This unit is used by climate scientists because the various
      greenhouse gases, such as CO₂, CH₄ and N₂O, have different effects on the
      greenhouse effect. For example, CH₄ has a much stronger effect than CO₂,
      but spends less time in the atmosphere and is therefore a potent
      greenhouse gas in the short term (in contrast to CO₂, which remains in the
      atmosphere for hundreds of years).
    </p>
    <p>
      The data comes from various sources, in particular the Swiss platform for
      mobility management tools <strong><i>mobitool.ch</i></strong
      >, the Swiss nutritional recommendations of
      <strong><i>sge-ssn.ch</i></strong> and the Federal Food Safety and
      Veterinary Office <strong><i>FSVO</i></strong
      >, internal BFH experts on digitalization and sustainability and the data
      set of the life cycle assessment provider
      <strong><i>esu-services</i></strong
      >. The data is carefully checked by internal and external experts.
    </p>
  </app-expansion-panel>
  <app-expansion-panel title="2. Who is behind this project?">
    <p>
      The <strong><i>Me and My Planet</i></strong> learning resource was
      designed and developed by the Sustainable Business Institute at Bern
      University of Applied Sciences (BFH) as an Open Educational Resource
      (OER). The online tool was developed by BFH's Digital Sustainability Lab.
      The project was funded by the 3FO Foundation, the Federal Office for the
      Environment (FOEN) as well as internal funds.
    </p>
  </app-expansion-panel>
  <app-expansion-panel
    title="3. Where can I find more information on this project?"
  >
    <p>
      A corresponding website with more information is currently under
      development and will be available soon. Stay tuned!
    </p>
  </app-expansion-panel>
  <app-expansion-panel
    title="4. Where can I find more information on the topic of ecological footprint and/or sustainable consumption?"
  >
    <p>
      <strong
        >For more information on ecological footprints and sustainable
        consumption, you can visit the following websites:</strong
      >
    </p>
    <ul>
      <li>
        <a
          href="https://www.wwf.ch/de/nachhaltig-leben/footprintrechner"
          target="_blank"
          >WWF Footprint Calculator</a
        >
      </li>
      <li>
        <a href="https://climatehero.me/de/" target="_blank">Climate Hero</a>
      </li>
      <li>
        <a
          href="https://co2.myclimate.org/de/footprint_calculators/new"
          target="_blank"
          >MyClimate</a
        >
      </li>
      <li>
        <a href="https://www.footprintcalculator.org/home/en" target="_blank"
          >Calculator of the Ecological Footprint Network</a
        >
      </li>
    </ul>

    <p><strong>Other valuable sources:</strong></p>
    <ul>
      <li>
        <a href="https://www.pik-potsdam.de/en" target="_blank"
          >Postdam Institute for Climate Impact Research</a
        >
      </li>
      <li>
        <a href="https://doughnuteconomics.org/tools" target="_blank"
          >Doughnut Economics Action Lab Tool-Box</a
        >
      </li>
      <li>
        <a href="https://www.klima-info.ch/climate-update" target="_blank"
          >Klima-info.ch</a
        >: A weekly press review on all aspects of the climate crisis from
        Switzerland and around the world
      </li>
      <li>
        <a href="https://wmo.int/" target="_blank"
          >World Meteorological Organisation</a
        >: News, Facts and Figures
      </li>
    </ul>

    <p>
      <strong
        >Funding of student projects and networking with committed
        students:</strong
      >
    </p>
    <ul>
      <li>
        <a href="https://students4sustainability.ch/" target="_blank"
          >Students4sustainability</a
        >
      </li>
    </ul>
  </app-expansion-panel>
  <app-expansion-panel title="5. How is my data processed?">
    <div>
      <p>
        The data processing policy of the
        <strong><i>Me and My Planet</i></strong>
        learning programme can be found
        <a href="/privacy-statements" target="_blank">here</a>.
      </p>
    </div>
  </app-expansion-panel>
  <app-expansion-panel title="6. How can I get in touch?">
    <div>
      <p>
        <strong>First and foremost:</strong> Please contact your teacher or the
        person coordinating the use of the learning programme if you have any
        issues.
      </p>
      <p>If you have...</p>
      <ul>
        <li>Any general questions about the tool or learning programme</li>
        <li>
          Suggestions for further technical or content-related development
        </li>
        <li>Interest in using this learning programme or tool elsewhere</li>
      </ul>
      <p>
        You are welcome to contact us at
        <a href="mailto:sustainability@bfh.ch"> sustainability&#64;bfh.ch </a> .
      </p>
    </div>
  </app-expansion-panel>
</mat-accordion>
